<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="filial.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Цвет</label>
            <div>
              <crm-color-picker [(color)]="filial.color"></crm-color-picker>
            </div>
            <small
              *ngIf="errors?.color"
              class="p-error">
              {{ errors.color | join }}
            </small>
          </div>

          <div
            *ngIf="filial.deleted"
            class="text-right">
            <p-tag
              severity="danger"
              value="Удален"
              styleClass="mt-2"></p-tag>
          </div>
        </div>
      </p-card>

      <div
        class="mt-3"
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit">
        <crm-directory-common-history
          [entityName]="DirectoryCommonHistoryTypeEnum.FILIAL"
          [entityId]="formStoreService.getState.forms[this.index]?.entityId"
          [apiService]="filialService">
        </crm-directory-common-history>
      </div>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveFilial()"></button>
      <div class="flex align-items-center gap-2">
        <button
          *ngIf="(form$ | async)?.isShowDelete && !filial.deleted"
          pButton
          label="Удалить"
          class="p-button-danger p-button-text"
          (click)="deleteFilial()"></button>
        <button
          *ngIf="(form$ | async)?.isShowDelete && filial.deleted"
          pButton
          icon="pi pi-undo"
          label="Восстановить"
          class="p-button-info p-button-text"
          (click)="restoreFilial()"></button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
